export const Props = () => ({
  //Объект Signal
  signal: {
    type: Object,
    required: false,
  },
});